import { Layout } from '@eventbrite/eds-layout';
import React from 'react';
import { PopularCities } from '../../../../types';
import PopularCitiesContainer from '../PopularCitiesContainer';
import TopDestinations from '../TopDestinations';

export interface HomeBottomShelfContainerProps {
    country_popular_cities?: PopularCities;
    enableTopDestinationsHomepage?: Boolean;
    enablePopularCitiesHomepage?: Boolean;
    launchThingsToDoPage?: Boolean;
}

const shouldDisplayPopularCities = (props: HomeBottomShelfContainerProps) => {
    const {
        country_popular_cities,
        enablePopularCitiesHomepage,
        launchThingsToDoPage,
    } = props;

    return (
        enablePopularCitiesHomepage &&
        launchThingsToDoPage &&
        country_popular_cities?.length
    );
};

export const HomeBottomShelfContainer: React.FunctionComponent<
    HomeBottomShelfContainerProps
> = (props) => {
    const { country_popular_cities, enableTopDestinationsHomepage } = props;

    return (
        <div className="eds-bg-color--grey-100">
            <Layout hasHorizontalGutters={true} maxWidth="large">
                {enableTopDestinationsHomepage && <TopDestinations />}
                {shouldDisplayPopularCities(props) && (
                    <PopularCitiesContainer cities={country_popular_cities} />
                )}
            </Layout>
        </div>
    );
};
